import { useLocation } from '@reach/router';
import React from 'react';

import { usePlannedDownTimeRedirect } from '../../hooks/usePlannedDownTimeRedirect';
import Helmet from 'react-helmet';
import { useTranslation } from '../../hooks/useTranslation';
import Registration from '../../components/registration';
import { useIsMobile } from '../../util/style-utils';
import useRegistrationForm from '../../hooks/useRegistrationForm';

export interface RegistrationPageProps {
  path: string;
}

export const RegistrationPages = () => {
  const { t } = useTranslation();
  usePlannedDownTimeRedirect();

  const location = useLocation();
  const locationState = location.state as any;
  const redirectUrl = locationState?.redirectUrl;
  const isMobile = useIsMobile();
  const defaultAccountNumber = locationState?.accountNumber;
  const form = useRegistrationForm(defaultAccountNumber, redirectUrl);

  return (
    <>
      <Helmet>
        <title>{t('REGISTRATION')}</title>
      </Helmet>

      <Registration form={form} isMobile={isMobile} />
    </>
  );
};

export default RegistrationPages;
